import { useState } from "react";

import { Checkbox } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent, actionNames, objectTypes } from "@newsela/snitch";
import { checkBoxLabelCss } from "./QuizAnswersSetting.style";

const CheckboxWithTrackEvent = withTrackEvent(Checkbox);

const propTypes = {
  assignmentId: PropTypes.string,
  currentContentLevel: PropTypes.object,
  isQuizRevealHidden: PropTypes.bool,
  onHideQuizRevealChange: PropTypes.func,
};

const QuizAnswersSetting = ({
  assignmentId,
  currentContentLevel,
  isQuizRevealHidden,
  onHideQuizRevealChange,
}) => {
  const [isHideQuizAnswersChecked, setIsHideQuizAnswersChecked] =
    useState(!isQuizRevealHidden);

  const eventProperties = {
    objectType: objectTypes.assignment,
    actionName: actionNames.update,
    streamProperties: {
      content_type: "Article",
      content_id: currentContentLevel?.id,
      content_ids: [currentContentLevel?.header_id],
      description: `Toggle students can listen to the article ${
        isQuizRevealHidden ? "on" : "off"
      }`,
      object_id: assignmentId,
    },
  };

  return (
    <CheckboxWithTrackEvent
      __cssFor={{ root: checkBoxLabelCss(isHideQuizAnswersChecked) }}
      checked={isHideQuizAnswersChecked}
      label="Reveal quiz answers to students after submission"
      name="Reveal quiz answers to students after submission"
      dataProps={{
        "data-qa-selector": `students_can_view_quiz_answers_${
          isQuizRevealHidden ? "on" : "off"
        }`,
      }}
      onClick={() => {
        setIsHideQuizAnswersChecked(
          (prevIsHideQuizAnswersChecked) => !prevIsHideQuizAnswersChecked,
        );
        onHideQuizRevealChange(!isQuizRevealHidden);
      }}
      {...eventProperties}
    />
  );
};

QuizAnswersSetting.propTypes = propTypes;

export default QuizAnswersSetting;
